import { useEffect, useRef } from "react";
import { useIsComponentMounted } from "../../hooks/useIsComponentMounted";
import NitroFilter from "../NitroFilter";

const ZipCodeFilter = ({
  value,
  setValue,
  disabled,
  zipCodes,
}: {
  value: string;
  setValue: (value: string) => void;
  disabled?: boolean;
  zipCodes?: string[];
}) => {
  const isComponentMounted = useIsComponentMounted();

  const zipCodeRef: React.MutableRefObject<any> = useRef();
  useEffect(() => {
    if (!isComponentMounted) return;
    if (zipCodeRef?.current && zipCodes && zipCodes.length > 0) {
      zipCodeRef?.current?.focus();
    }
  }, [zipCodes, zipCodeRef, isComponentMounted]);

  return (
    <NitroFilter
      data={{
        options: [
          // { label: "", value: "" },
          ...(zipCodes && zipCodes.length > 0
            ? zipCodes.map((r) => ({ label: r, value: r }))
            : [{ label: value, value }]),
        ],
      }}
      config={{
        inputRef: zipCodeRef,
        // autoFocus: true,
      }}
      value={value}
      setValue={setValue}
      disabled={disabled}
      size="small"
      placeholder="Zip code"
    />
  );
};

export default ZipCodeFilter;
